import { createAction } from 'redux-actions';

export const resetFormPackageItems = createAction('RESET_FORM_PACKAGE_ITEMS');

export const incrementQtyInventoryPackageItem = createAction(
  'INCREMENT_QTY_INVENTORY_PACKAGE_ITEM'
);

export const decrementQtyInventoryPackageItem = createAction(
  'DECREMENT_QTY_INVENTORY_PACKAGE_ITEM'
);

export const addInventoryPackageItem = createAction(
  'ADD_INVENTORY_PACKAGE_ITEM'
);

export const deleteInventoryPackageItem = createAction(
  'DELETE_INVENTORY_PACKAGE_ITEM'
);

export const undoDeleteInventoryPackageItem = createAction(
  'UNDO_DELETE_INVENTORY_PACKAGE_ITEM'
);

export const clearPackageItems = createAction('CLEAR_INVENTORY_PACKAGE_ITEMS');

export const clearPackageActiveReservationOrderItemsCount = createAction(
  'CLEAR_INVENTORY_PACKAGE_ACTIVE_RESERVATION_ORDER_ITEMS_COUNT'
);

export const addItemOption = createAction('ADD_INVENTORY_ITEM_OPTION');

export const updateItemOption = createAction('UPDATE_INVENTORY_ITEM_OPTION');

export const removeItemOption = createAction('REMOVE_INVENTORY_ITEM_OPTION');
